<div class="toolbox-container" [class.disabled]="!isToolboxEnabled()" *hasCapability="CapabilityType.EDIT_PLANOGRAM">
  <button class="btn btn-sm btn-secondary" (click)="adjustFacings('h', 1)">
    <i class="bi bi-patch-plus fs-5"></i><br />
    H Facings
  </button>
  <button class="btn btn-sm btn-secondary" (click)="adjustFacings('h', -1)">
    <i class="bi bi-patch-minus fs-5"></i><br />
    H Facings
  </button>
  <button class="btn btn-sm btn-secondary" (click)="adjustFacings('v', 1)">
    <i class="bi bi-patch-plus fs-5"></i><br />
    V Facings
  </button>
  <button class="btn btn-sm btn-secondary" (click)="adjustFacings('v', -1)">
    <i class="bi bi-patch-minus fs-5"></i><br />
    V Facings
  </button>
  <div class="d-flex flex-column align-items-center bg-secondary py-3 gap-1">
    <span class="text-white">Orientation</span>
    <div ngbDropdown class="d-inline-block">
      <button class="btn btn-light btn-sm" ngbDropdownToggle>
        {{ orientationEnum[selectedOrientation] }}
      </button>
      <div ngbDropdownMenu>
        <button ngbDropdownItem (click)="updateOrientation({target: {value: orientationEnum.FRONT}})">
          Front
        </button>
        <button ngbDropdownItem (click)="updateOrientation({target: {value: orientationEnum.SIDE}})">
          Side
        </button>
        <button ngbDropdownItem (click)="updateOrientation({target: {value: orientationEnum.FLATPACK}})">
          Flatpack
        </button>
      </div>
    </div>
  </div>
</div>

<div class="dropdowns-container">
  <!-- Labels Dropdown -->
  <div class="dropdown-section my-2" ngbDropdown>
    <button class="btn btn-sm btn-light w-100" ngbDropdownToggle>
      Labels
    </button>
    <div ngbDropdownMenu class="dropdown-menu">
      <button ngbDropdownItem (click)="setLabels(labelType.BARCODE)">Barcode</button>
      <button ngbDropdownItem (click)="setLabels(labelType.BRAND)">Brand</button>
      <button ngbDropdownItem (click)="setLabels(labelType.FLOW)">Flow</button>
      <button ngbDropdownItem (click)="setLabels(labelType.UOS)">UOS</button>
      <button ngbDropdownItem (click)="setLabels(labelType.DOS)">DOS</button>
      <button ngbDropdownItem (click)="setLabels(labelType.SALE_QTY)">Volume</button>
      <button ngbDropdownItem (click)="setLabels(labelType.SALES)">Sales</button>
      <button ngbDropdownItem (click)="setLabels(labelType.AVG_PRICE)">Avg Price</button>
      <button ngbDropdownItem (click)="setLabels(labelType.DESC)">Description</button>
      <button ngbDropdownItem (click)="setLabels(labelType.CAPACITY_CASEPACK)">Capacity / Case Pack</button>
      <hr/>
      <label class="ps-2 my-1">Custom Label</label>
      <div class="d-flex gap-1 justify-content-between">
        <button ngbDropdownItem (click)="setLabels(labelType.DESC1)">1</button>
        <button ngbDropdownItem (click)="setLabels(labelType.DESC2)">2</button>
        <button ngbDropdownItem (click)="setLabels(labelType.DESC3)">3</button>
        <button ngbDropdownItem (click)="setLabels(labelType.DESC4)">4</button>
        <button ngbDropdownItem (click)="setLabels(labelType.DESC5)">5</button>
      </div>
      <hr/>
      <label class="ps-2 my-1">Custom Value</label>
      <div class="d-flex gap-1 justify-content-between">
        <button ngbDropdownItem (click)="setLabels(labelType.VAL1)">1</button>
        <button ngbDropdownItem (click)="setLabels(labelType.VAL2)">2</button>
        <button ngbDropdownItem (click)="setLabels(labelType.VAL3)">3</button>
        <button ngbDropdownItem (click)="setLabels(labelType.VAL4)">4</button>
        <button ngbDropdownItem (click)="setLabels(labelType.VAL5)">5</button>
      </div>
      <hr/>
      <button ngbDropdownItem (click)="clearLabels()">Clear</button>
    </div>
  </div>

  <!-- Overlays Dropdown -->
  <div class="dropdown-section" ngbDropdown>
    <button class="btn btn-sm btn-light w-100" ngbDropdownToggle>
      Overlays
    </button>
    <div ngbDropdownMenu class="dropdown-menu">
      <button ngbDropdownItem (click)="setOverlay(overlayType.DOS)">DOS</button>
      <button ngbDropdownItem (click)="setOverlay(overlayType.CPI_CATEGORY)">CPI - Category</button>
      <button ngbDropdownItem (click)="setOverlay(overlayType.CPI_SEGMENT)">CPI - Segment</button>
      <button ngbDropdownItem (click)="setOverlay(overlayType.SEGMENT)">Segment</button>
      <button ngbDropdownItem (click)="setOverlay(overlayType.SEGMENT_FAMILY)">Segment - Family</button>
      <button ngbDropdownItem (click)="setOverlay(overlayType.RSP)">RSP</button>
      <button ngbDropdownItem (click)="setOverlay(overlayType.CASE_PACK)">Case Pack</button>
      <hr/>
      <label class="ps-2 my-1">Product Lifecycle</label>
      <button ngbDropdownItem (click)="setOverlay(overlayType.LIFECYCLE_STATUS)">Status</button>
      <button ngbDropdownItem (click)="setOverlay(overlayType.LIFECYCLE_RANGE)">Range</button>
      <button ngbDropdownItem (click)="setOverlay(overlayType.LIFECYCLE_PLAN)">Plan</button>
      <hr/>
      <button ngbDropdownItem (click)="clearOverlay()">Clear</button>
    </div>
  </div>
</div>